import React from "react";

import "./style.scss";

export interface Props {
    values: number[];
}

function polarToCartesian(centerX: number, centerY: number, radius: number, angleInDegrees: number) {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians)
    };
}

function describeArc(startPercent: number, endPercent: number): string {
    const x = 95;
    const y = 95;
    const radius = 88;
    const startAngle = startPercent * 360;
    const endAngle = endPercent * 360;

    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);

    const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

    const d = ["M", start.x, start.y, "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(" ");

    return d;
}

const joinValues = (values: number[], to: number): number =>
    values.reduce((acc, val, index) => {
        if (index < to) {
            return acc + val;
        }

        return acc;
    }, 0);

export const PieChart = ({ values }: Props) => {
    return (
        <svg className="pieChart" viewBox={`0 0 190 190`} xmlns="http://www.w3.org/2000/svg">
            <circle cx={95} cy={95} r={88} className={`bg c${values.length}`} />
            {values[3] && <path d={describeArc(joinValues(values, 3), joinValues(values, 4))} className="p4" />}
            {values[2] && <path d={describeArc(joinValues(values, 2), joinValues(values, 3))} className="p3" />}
            {values[1] && <path d={describeArc(joinValues(values, 1), joinValues(values, 2))} className="p2" />}
            {values[0] && <path d={describeArc(0, values[0])} className="p1" />}
        </svg>
    );
};
